import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { auth } from './plugins/firebase'
import configMap from './plugins/googleMaps'
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'
import JsonCSV from 'vue-json-csv'

Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)
Vue.use(VueGoogleMaps, configMap)

Vue.config.productionTip = false

let app

console.log('SOLAR 1.6.4')

auth.onAuthStateChanged(async () => {

    if (!app) {
        app = new Vue({
            router,
            store,
            vuetify,
            render: (h) => h(App),
        }).$mount('#app')
    }
    try {
        const user = await store.dispatch('user/checkLogin')
        await store.dispatch('account/init', user)
        await store.dispatch('gateways/init')
        await store.dispatch('meters/init')
    } catch (error) {
        console.log('error')
    }
    
})
